import { render, staticRenderFns } from "./ChangedPasswordModal.vue?vue&type=template&id=054e9ac8&scoped=true&"
import script from "./ChangedPasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangedPasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e9ac8",
  null
  
)

export default component.exports